import { Spinner, Wrapper } from 'components';
import { useFetchTransactions } from '../../hooks/useFetchTransactions';
import useIsProjectRoute from 'hooks/use-is-project-route';
import styles from './styles.module.scss';
import { useSelector } from 'react-redux';
import {
  getAggregatePageTransactionsSelector,
  getTransactionsSearchSelector,
  getTransactionsSelector,
} from 'store/selectors/transactions';
import { getUserRoleSelector } from 'store/selectors/user';
import { TransactionTabs } from './TransactionTabs';
import { TransactionsAndProjectsTable } from 'pages/Workshop/Transactions/components/TransactionsAndProjectsTable';
import { PageWrapper } from 'pages/Workshop/PageWrapper';
import { ProjectTabs } from './ProjectTabs';
import classNames from 'classnames';
import { SearchPlaceholderView } from 'pages/Workshop/components/SearchPlaceholderView';

export const TransactionContent = (props) => {
  const { className, isSearchActive } = props;
  const { loading } = useFetchTransactions();
  const { isArchive, transactionFilter, isFiltersApplied, projectFilter } =
    useSelector(getTransactionsSelector);
  const isProject = useIsProjectRoute();
  const transactionsState = useSelector(getAggregatePageTransactionsSelector);
  const userRole = useSelector(getUserRoleSelector);
  const search = useSelector(getTransactionsSearchSelector);

  const tabItemsProps = {
    isArchive,
    userRole,
    transactionFilter,
    isFiltersApplied,
    projectFilter,
    transactions: transactionsState?.transactions,
    loading,
  };

  if (isSearchActive && !search) {
    return <SearchPlaceholderView isPending={loading} />;
  }

  if (isSearchActive || isFiltersApplied)
    return (
      <PageWrapper
        className={classNames(styles.transactionProjectWrapper, className)}
        testId="transactions_page"
        isContainer={false}
        isHideFooter
      >
        <Wrapper isPending={loading}>
          <TransactionsAndProjectsTable
            isFiltersApplied={isFiltersApplied}
            isArchive={isArchive}
            transactionFilter={transactionFilter}
            projectFilter={projectFilter}
            includeArchive
            isLoading={loading}
          />
        </Wrapper>
      </PageWrapper>
    );

  return (
    <div className={className}>
      {!isProject ? <TransactionTabs {...tabItemsProps} /> : <ProjectTabs {...tabItemsProps} />}
    </div>
  );
};
